import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { PackagingPOTransformConfig } from 'components/packaging/components/packagingPOV2/PackagingPOFilterConfig';
import { PackagingPOFilters } from 'components/packaging/components/packagingPOV2/PackagingPOFilters';
import { PackagingPOTable } from 'components/packaging/components/packagingPOV2/PackagingPOTable';
import { usePackagingPurchaseOrders } from 'components/packaging/components/packagingPOV2/queries/PackagingPOQueries';
import { UserContext } from 'contexts/UserContext';
import { Button } from 'shadcn/components/ui/Button';
import { fromUrl, pushToUrl, removeEmptyFilters } from 'shared';

export function ViewPackagingPOV2() {
    const history = useHistory();
    const location = useLocation();
    const user = useContext(UserContext);
    const facilityID = user?.getFacilityID?.();
    const [filters, setFilters] = useState(() =>
        typeof window !== 'undefined' ? fromUrl(location.search, PackagingPOTransformConfig) : {},
    );
    const statusFilter = '';

    const purchaseOrdersQuery = usePackagingPurchaseOrders({
        status: statusFilter,
        facilityID,
    });

    const { data, error, isFetching, isLoading } = purchaseOrdersQuery;
    const rows = useMemo(() => (Array.isArray(data) ? data : []), [data]);
    const errorMessage = error?.message ?? '';

    const handleCreatePurchaseOrder = useCallback(() => {
        history.push('/packaging/createPurchaseOrder-v2');
    }, [history]);

    const handleBulkCreatePurchaseOrders = useCallback(() => {
        history.push('/packaging/bulkCreatePurchaseOrders-v2');
    }, [history]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        setFilters(fromUrl(location.search, PackagingPOTransformConfig));
    }, [location.search]);

    const handleDummyFetch = useCallback(() => {
        // TODO: replace with real filtered packaging PO endpoint when available
    }, []);

    const handleFilterChange = useCallback(
        (nextFilters) => {
            setFilters(nextFilters);
            pushToUrl(removeEmptyFilters(nextFilters), PackagingPOTransformConfig, { replace: false });
            handleDummyFetch();
        },
        [handleDummyFetch],
    );

    return (
        <div className="flex min-h-screen flex-col">
            <div className="px-4 pt-4">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-semibold">Packaging Purchase Orders V2</h1>
                    <div>
                        <Button size="sm" className="mr-2" onClick={handleBulkCreatePurchaseOrders}>
                            Bulk Create Purchase Orders
                        </Button>
                        <Button size="sm" onClick={handleCreatePurchaseOrder}>
                            Create Purchase Order
                        </Button>
                    </div>
                </div>
                <div className="mt-4">
                    <PackagingPOFilters initialValues={filters} onChange={handleFilterChange} />
                </div>
            </div>
            <div className="flex flex-1 flex-col px-4 pb-6 pt-4">
                {errorMessage ? (
                    <div className="mb-4 rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
                        {errorMessage}
                    </div>
                ) : null}
                <PackagingPOTable data={rows} isFetching={isFetching} isLoading={isLoading} />
            </div>
        </div>
    );
}

ViewPackagingPOV2.displayName = 'ViewPackagingPOV2';
